<template>
	<InstallableDetailsBox :installable="selectedWorkflowInstallable" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { getSelectedWorkflowInstallable } from '@/store/modules/selectedWorkflow/getters';
import { mapGetters } from 'vuex';
import InstallableDetailsBox from '../Installables/InstallableDetailsBox.vue';
export default {
	name: 'FlowConfigPanelInstallableCard',
	components: { InstallableDetailsBox },
	computed: {
		...mapGetters([getSelectedWorkflowInstallable.fullPath]),
		selectedWorkflowInstallable() {
			return this[getSelectedWorkflowInstallable.fullPath];
		},
	},
};
</script>

<style scoped lang="scss"></style>
